import React, { useState, useEffect, useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
// import { ClinicContext } from '../../context/ClinicContext'
import UserDetailsForm from './userDetailsForm';
import BusinessDetailsForm from './businessDetailsForm';
import PricingDetailsForm from './PricingDetailsForm';
// import SubscriptionDetailsForm from './subscriptionDetailsForm';
import SummaryForm from './summaryForm';
//import RoleSelectionForm from './roleSelectionForm';
import OtpScreen from './otpScreen.component';
import StandardModal from '../Modals/standardModal';
import './form.css';
import FormatUrl from '../../utils/UrlFormatter';
import { getClinicId, isWhiteLabelEnabled } from '../../utils/config';


const RegistrationCompleteForm = ({ account, logout, logged_in, user }) => {
  const { t } = useTranslation();

  // const { clinicId, setClinicId } = useContext(ClinicContext);
  const clinicId = getClinicId(user);

  const isWhiteLabel = isWhiteLabelEnabled();
  // Modal state management
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');

  const initialRole = isWhiteLabel ? "PA" : "CO";

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    role: initialRole,
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    business_name: '',
    business_number:'',
    registry_id: '',
    business_operating_as: '',
    type_of_business: '',
    zipcode: '',
    city: '',
    state: '',
    country: 'CA',
    address_line_1: '',
    address_line_2: '',
    business_phone: '',
    business_email: '',
    // selectedPlan:'',
    companyURL: '' ,
    max_practitioners: '',

  });
  const [otpId, setOtpId] = useState(null);
  const [profileStagingId, setProfileStagingId] = useState(null);
  const [csrfToken, setCsrfToken] = useState('');
  const { executeRecaptcha } = useGoogleReCaptcha();
  const navigate = useNavigate();

  const fetchCsrfToken = async () => {
    try {
      let csrfUrl = FormatUrl(`/csrf-token/`);
      const response = await fetch(csrfUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch CSRF token');
      }

      const data = await response.json();
      setCsrfToken(data.csrfToken);
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
      setModalTitle('Error');
      setModalMessage('Failed to fetch CSRF token.');
      setIsModalVisible(true); // Show the modal for CSRF error
    }
  };

  useEffect(() => {
    fetchCsrfToken();
  }, []);


  const nextStep = () => {
  setStep((prevStep) => prevStep + 1); 
  window.scrollTo(0, 0); 
  };

  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
    window.scrollTo(0, 0); 
  };

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  const handleSubmit = async () => {
    if (!executeRecaptcha) {
      setModalTitle(t("register_main.recaptcha_error"));
      setModalMessage(t("register_main.recaptcha_not_ready"));
      setIsModalVisible(true); // Show modal instead of alert
      return;
    }

    const token = await executeRecaptcha('register');

    if (!token) {
      setModalTitle(t("register_main.recaptcha_error"));
      setModalMessage(t("register_main.recaptcha_failed"));
      setIsModalVisible(true); // Show modal instead of alert
      return;
    }

    if (!csrfToken) {
      await fetchCsrfToken();
    }

    //  Set "N/A" for companyURL if it's not filled
    const companyURL = formData.companyURL ? formData.companyURL : 'N/A';
  
    const submissionData = new FormData();
    const data = {
      role: formData.role,
      email: formData.email,
      firstName: formData.firstName,
      lastName: formData.lastName,
      phone: `+1${formData.phone}`,
      business_name: formData.business_name,
      business_number: formData.business_number,
      registry_id: '00000000',
      business_operating_as: formData.business_operating_as,
      type_of_business: formData.type_of_business,
      zipcode: formData.zipcode,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      address_line_1: formData.address_line_1,
      address_line_2: formData.address_line_2,
      business_phone: formData.business_phone,
      business_email: formData.business_email,
      companyURL: companyURL ,
      max_practitioners: formData.max_practitioners,
      clinic_id: clinicId
    };

    if (formData.value_added_services === true) {
      data.value_added_services = true;
    }
    
    submissionData.append('data', JSON.stringify(data));
    submissionData.append('captchaToken', token);

    try {
      let myHeaders = new Headers();
      myHeaders.append("X-CSRFToken", csrfToken);

      let respUrl = FormatUrl(`/signup/`);
      const response = await fetch(respUrl, {
        method: 'POST',
        headers: myHeaders,
        body: submissionData,
        credentials: 'include',
      });

      const responseData = await response.json();

      if (response.ok && responseData.status === "Success") {
        setOtpId(responseData.otp_id);
        setProfileStagingId(responseData.profile_staging_id);    
        setStep(5);
      } else {
        setModalTitle(t("register_main.submission_error"));
        setModalMessage(t("register_main.form_submission_failed"));
        setIsModalVisible(true); // Show modal instead of alert
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setModalTitle('Submission Error');
      setModalMessage('Form submission failed. Please try again.');
      setIsModalVisible(true); // Show modal instead of alert
    }
  };
  
  const handleOtpSubmit = async (otp) => {

    try {
      let myHeaders = new Headers();
      myHeaders.append("X-CSRFToken", csrfToken);

      const formData = new FormData();
      formData.append('otp_id', otpId);
      formData.append('otp', otp);
      formData.append('profile_staging_id', profileStagingId);

      // Retrieve clinic_id from the context and send it to the backend
      formData.append('clinic_id', clinicId); 

      let otpUrl = FormatUrl(`/signup-otp/`);
      const response = await fetch(otpUrl, {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        credentials: 'include',
      });

      const responseData = await response.json();

      if (response.ok && responseData.status === "Success") {

        // Store clinic_id in the context if needed
        // setClinicId(responseData.clinic_id);

        sessionStorage.setItem("triggerLogin", isWhiteLabel ? "true" : "false");
        navigate('/registration-success');
      } else {
        setModalTitle(t("register_main.otp_error"));
        setModalMessage(t("register_main.otp_verification_failed"));
        setIsModalVisible(true); // Show modal instead of alert
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setModalTitle('OTP Error');
      setModalMessage('OTP verification failed. Please try again.');
      setIsModalVisible(true); // Show modal instead of alert
    }
  };

  // const renderStep = () => {
  //   switch (step) {
  //     case 1:
  //       return <RoleSelectionForm formData={formData} handleChange={handleChange} nextStep={nextStep} />;
  //     case 2:
  //       return <UserDetailsForm 
  //         formData={formData} 
  //         handleChange={handleChange} 
  //         nextStep={nextStep} 
  //         prevStep={prevStep} 
  //       />;
  //     case 3:
  //       return (formData.role === 'CA') ? (
  //         <BusinessDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} prevStep={prevStep} />
  //       ) : (
  //         <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
  //       );
  //     // case 4:
  //     //   return (formData.role === 'CA') && (
  //     //     <SubscriptionDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} prevStep={prevStep} />
  //     //   );
  //     case 4:
  //       return (formData.role === 'CA') && (
  //         <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
  //       );
  //     case 5:
  //       return <OtpScreen handleOtpSubmit={handleOtpSubmit} />;
  //     default:
  //       return null;
  //   }
  // };

  // const renderStep = () => {
  //   switch (step) {
  //     case 1:
  //       return <RoleSelectionForm formData={formData} handleChange={handleChange} nextStep={nextStep} />;
  //     case 2:
  //       return <UserDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} prevStep={prevStep} />;
  //     case 3:
  //       return (formData.role === 'CA') ? (
  //         <BusinessDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} prevStep={prevStep} />
  //       ) : (
  //         <div className="summary-full-width">
  //           <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
  //         </div>
  //       );
  //     case 4:  // This should now always be SummaryForm
  //       return <div className="summary-full-width">
  //               <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
  //             </div>
  //     case 5:  // OTP Screen remains the last step
  //       return <OtpScreen handleOtpSubmit={handleOtpSubmit} />;
  //     default:
  //       return null;
  //   }
  // };
  

  // const renderStep = () => {
  //   switch (step) {
  //     case 1:
  //       return <UserDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} />;
  //     case 2:
  //       return (formData.role === 'CA' || formData.role === 'CO') ? (
  //         <BusinessDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} prevStep={prevStep} />
  //       ) : (
  //         <div className="summary-full-width">
  //           <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
  //         </div>
  //       );
  //     case 3:  // This should now always be SummaryForm
  //       return <div className="summary-full-width">
  //               <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
  //             </div>
  //     case 4:  // OTP Screen remains the last step
  //       return <OtpScreen handleOtpSubmit={handleOtpSubmit} />;
  //     default:
  //       return null;
  //   }
  // };
  const renderStep = () => {
    switch (step) {
      case 1:
        return <UserDetailsForm formData={formData} handleChange={handleChange} nextStep={nextStep} />;
      case 2:
        return (formData.role === 'CA' || formData.role === 'CO') ? (
          <BusinessDetailsForm
            formData={formData}
            handleChange={handleChange}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        ) : (
          <div className="summary-full-width">
            <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
          </div>
        );
      case 3:
        return <PricingDetailsForm
            formData={formData}
            handleChange={handleChange}
            nextStep={nextStep}
            prevStep={prevStep}
          />
      
      case 4:
        return (
          <div className="summary-full-width">
            <SummaryForm formData={formData} prevStep={prevStep} handleSubmit={handleSubmit} />
          </div>
        );
      case 5:
        return <OtpScreen handleOtpSubmit={handleOtpSubmit} />;
      default:
        return null;
    }
  };
  

  return (
    <section className="section single-page">
      <div className="section-title" style={{ marginTop: '1rem' }}>
        <h3>{t("register_main.signup_register")}</h3>
        <div className="underline"></div>
      </div>
      <div className="section-center page-info" style={{maxWidth:'1150px'}}>
        {renderStep()}
      </div>

      {/* StandardModal for showing error or validation messages */}
      <StandardModal
        isOpen={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        title={modalTitle}
        message={modalMessage}
      />
    </section>
  );
};

export default RegistrationCompleteForm;
